var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighlights4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 85,
    viewBox: "0 0 121 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2062_656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121 15.7868H112.53V0H85.9104C76.1155 0 69.5927 6.53846 65.8282 12.5829C65.1767 13.6145 64.5903 14.6607 64.0473 15.685C62.6808 18.3008 61.512 21.0158 60.5507 23.8073C59.5894 21.0158 58.4205 18.3008 57.054 15.685C56.5111 14.6607 55.9247 13.6145 55.2731 12.5829C51.5086 6.53846 44.9569 0 35.162 0H8.47014V15.7868H0V80.147H48.4029V85H72.6043V80.147L120.942 80.0889H121V15.7868Z",
    fill: "#F9D7BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2062_656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 85,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlights4);
export default __webpack_public_path__ + "static/media/highlights-4.8986e0a1c5b49ca28acec67e5655a1bc.svg";
export { ForwardRef as ReactComponent };